import { ListsEditor } from "./ListsEditor.js";
import * as Normalizations from "./normalizations/index.js";
/**
 * All plugin normalizations combined into a single function.
 */
export function normalizeNode(editor, entry) {
  const schema = ListsEditor.getListsSchema(editor);
  if (schema) {
    return normalizeNode.normalizeListChildren(editor, schema, entry) || normalizeNode.normalizeListItemChildren(editor, schema, entry) || normalizeNode.normalizeListItemTextChildren(editor, schema, entry) || normalizeNode.normalizeOrphanListItem(editor, schema, entry) || normalizeNode.normalizeOrphanListItemText(editor, schema, entry) || normalizeNode.normalizeOrphanNestedList(editor, schema, entry) || normalizeNode.normalizeSiblingLists(editor, schema, entry);
  }
  return false;
}
(function (_normalizeNode) {
  const normalizeListChildren = _normalizeNode.normalizeListChildren = Normalizations.normalizeListChildren;
  const normalizeListItemChildren = _normalizeNode.normalizeListItemChildren = Normalizations.normalizeListItemChildren;
  const normalizeListItemTextChildren = _normalizeNode.normalizeListItemTextChildren = Normalizations.normalizeListItemTextChildren;
  const normalizeOrphanListItem = _normalizeNode.normalizeOrphanListItem = Normalizations.normalizeOrphanListItem;
  const normalizeOrphanListItemText = _normalizeNode.normalizeOrphanListItemText = Normalizations.normalizeOrphanListItemText;
  const normalizeOrphanNestedList = _normalizeNode.normalizeOrphanNestedList = Normalizations.normalizeOrphanNestedList;
  const normalizeSiblingLists = _normalizeNode.normalizeSiblingLists = Normalizations.normalizeSiblingLists;
})(normalizeNode || (normalizeNode = {}));